export class Options {
  slow = 15;
  remote = false;

  get delay(): number {
    return 10 * Math.pow(1.3, this.slow);
  }
}
